// extracted by mini-css-extract-plugin
export default {"ActiveLink":"MenuItem_ActiveLink__9+XxD","Link":"MenuItem_Link__mfEFx","DownButton":"MenuItem_DownButton__Bz-52","Open":"MenuItem_Open__wvKMS","SubNav":"MenuItem_SubNav__d07nt"};